import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface ScheduledDropFilters {
  studentId?: string;
  studentName?: string;
  enrollmentId?: string;
  scheduledDropDateFrom?: string;
  scheduledDropDateTo?: string;
  shouldRefund?: boolean;
  status?: 'pending' | 'executed' | 'cancelled';
}

export interface ScheduledDropResponse {
  id: string;
  studioId: string;
  studentId: string;
  enrollmentId: string;
  scheduledDropDate: string;
  dropReason: string;
  shouldRefund: boolean;
  status: 'pending' | 'executed' | 'cancelled';
  createdBy: 'studio' | 'parent';
  approvedByStudio: boolean;
  executedAt?: string;
  executionError?: string;
  createdAt: string;
  updatedAt: string;
  // Populated fields
  student?: {
    _id: string;
    firstName: string;
    lastName: string;
  };
  enrollment?: {
    _id: string;
    name: string;
    tuition: number;
  };
}

export const getScheduledDropsAPI = async (
  filters?: ScheduledDropFilters,
): Promise<ScheduledDropResponse[]> => {
  const queryParams = new URLSearchParams();

  if (filters?.studentId) queryParams.append('studentId', filters.studentId);
  if (filters?.studentName) queryParams.append('studentName', filters.studentName);
  if (filters?.enrollmentId) queryParams.append('enrollmentId', filters.enrollmentId);
  if (filters?.scheduledDropDateFrom) queryParams.append('scheduledDropDateFrom', filters.scheduledDropDateFrom);
  if (filters?.scheduledDropDateTo) queryParams.append('scheduledDropDateTo', filters.scheduledDropDateTo);
  if (filters?.shouldRefund !== undefined) queryParams.append('shouldRefund', String(filters.shouldRefund));
  if (filters?.status) queryParams.append('status', filters.status);

  const response = await baseAPI.get<ScheduledDropResponse[]>(
    `/scheduled-drops${queryParams.toString() ? `?${queryParams.toString()}` : ''}`,
  );
  return response.data;
};

export const useGetScheduledDrops = (filters?: ScheduledDropFilters) => {
  return useQuery({
    queryKey: [KEYS.SCHEDULED_DROPS, filters],
    queryFn: () => getScheduledDropsAPI(filters),
  });
};
